module.exports = __webpack_public_path__ + "img/female_default.341fc6b9.png";